'use strict';

module.exports = [
    'Jr.',
    'Sr.',
    'I',
    'II',
    'III',
    'IV',
    'V',
    'VI',
    'VII',
    'VIII',
    'IX',
    'X'
].map((code) => {
    return { display: code, code: code.toUpperCase() };
});
